<template>
    <div class="input">
        <header class="input__header">
            <h1>Markov Machine</h1>

            <p>
                <em>By <a href="https://www.haykranen.nl/?ref=markovmachine" target="_blank">Hay Kranen</a></em>
            </p>
        </header>

        <el-form
            v-model="input"
            v-bind:add-index="addIndex"
            v-bind:type="formType"
            v-on:submit="addInput"></el-form>

        <button
            class="button button--link"
            v-on:click="showOptions = !showOptions">
            <span v-if="showOptions">Hide options</span>
            <span v-if="!showOptions">Show options</span>
        </button>

        <menu class="input__buttons"
              v-show="showOptions">
            <button
                class="button"
                v-on:click="addAnimals">Add animals</button>

            <button
                class="button"
                v-on:click="clear">Clear</button>

            <button
                class="button"
                v-on:click="toggleFormType">Toggle formtype</button>

            <div class="button">
                <input id="add-index"
                       type="checkbox"
                       v-model="addIndex" />

                <label for="add-index">Add index</label>
            </div>

            <div class="button">
                <input id="generate-unique"
                       type="checkbox"
                       v-model="generateUnique" />

                <label for="generate-unique">Generate unique</label>
            </div>
        </menu>

        <button
            class="button button--big"
            v-bind:disabled="corpus.length === 0"
            v-on:click="generate">Generate</button>

        <h2 class="input__chars"
            v-if="!!generated">
            <el-char
                v-for="(char, index) in generated"
                v-bind:key="index"
                flair="output"
                v-bind:char="char"></el-char>
        </h2>

        <div class="input__predictor input__predictor--wide"
             v-if="!!starters.length">
            <el-char char="Starters"
                     class="input__predictor-id"
                     flair="label-text"></el-char>

            <ul class="input__predictor-chars">
                <el-char v-for="(char, index) in starters"
                         v-bind:key="index"
                         color="red"
                         v-bind:char="char"></el-char>
            </ul>
        </div>

        <ul class="input__predictors">
            <li v-for="(predictor, id) in predictors"
                v-bind:key="id"
                class="input__predictor">
                <el-char v-bind:char="predictor.char"
                         class="input__predictor-id"
                         v-bind:index="addIndex ? String(predictor.index) : false"
                         flair="label"></el-char>

                <ul class="input__predictor-chars">
                    <el-char v-for="(item, index) in predictor.items"
                            v-bind:key="index"
                            v-bind:char="item"></el-char>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from 'axios';
    import { sample } from 'donot';
    import Vue from 'vue';
    import ElChar from './el-char.vue';
    import ElForm from './el-form.vue';
    import { clone } from '../util.js';

    const PATH = process.env.BASE_URL;

    export default {
        components : { ElChar, ElForm },

        data() {
            return {
                addIndex : false,
                corpus : [],
                formType : 'text',
                input : "",
                generated : '',
                generateUnique : false,
                predictors : {},
                showOptions : false,
                starters : []
            };
        },

        methods : {
            addInput() {
                this.input.split('\n').forEach(i => this.addToken(i.trim()));
                this.input = '';
            },

            addToken(token) {
                this.corpus.push(token);

                const chars = token.split('');

                this.starters.push(chars[0]);

                chars.forEach((char, index) => {
                    const item = token.slice(index + 1, index + 2);

                    let id = char;

                    if (this.addIndex) {
                        id = `${char}:${index}`;
                    }

                    if (id in this.predictors) {
                        this.predictors[id].items.push(item)
                    } else {
                        this.predictors[id] = {
                            char : char,
                            id : id,
                            index : index,
                            items : [ item ]
                        };
                    }
                });
            },

            async addAnimals() {
                const req = await axios.get(`${PATH}data/animals.txt`);
                req.data.split('\n').forEach(a => this.addToken(a));
            },

            clear() {
                this.corpus = [];
                this.generated = '';
                this.input = "";
                this.predictors = {};
                this.starters = [];
            },

            async generate() {
                this.generated = '';
                await Vue.nextTick();

                if (this.generateUnique) {
                    let word = '';

                    do {
                        word = this.generateToken();
                    } while (this.corpus.includes(word));

                    this.generated = word;
                } else {
                    this.generated = this.generateToken();
                }
            },

            generateToken() {
                const generated = [];

                let char = sample(clone(this.starters));
                let index = 0;
                generated.push(char);

                while (true) {
                    const key = this.addIndex ? `${char}:${index}` : char;
                    char = sample(clone(this.predictors[key].items));

                    if (char === '') {
                        break;
                    }

                    generated.push(char);
                    index = index + 1;
                }

                return generated.join('');
            },

            toggleFormType() {
                this.formType = this.formType === 'text' ? 'area' : 'text';
            }
        }
    }
</script>